import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import MoreVertRounded from "@mui/icons-material/MoreVertRounded";
import { Button, Divider, IconButton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { MouseEvent, useState } from "react";
import EditCategoryPopover from "./EditCategoryPopover";
import AddSubCategory from "./AddSubCategory";
import EditSubCategoryPopover from "./EditSubCategoryPopover";
import ValidateAccess from "components/ValidateAccess";
import { Permissions } from "data/permissons";

type Props = {
  data: any;
};

function CategoryCard({ data }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorSubCatEl, setAnchorSubCatEl] = useState<null | HTMLElement>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [openAddSubCategory, setOpenAddSubCategory] = useState<boolean>(false);
  const [selectedSubCategory, setSelectedSubCategory] = useState<any>(null);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSubCategoryClick = (
    event: MouseEvent<HTMLElement>,
    item: any
  ) => {
    setSelectedSubCategory(item);
    setAnchorSubCatEl(event.currentTarget);
  };

  return (
    <>
      <Box
        sx={{
          boxShadow: "0px 3px 12px #0000001A",
          borderRadius: 2,
        }}
      >
        <Box display="flex" p={2} gap={1} justifyContent="space-between">
          <Box display="flex" gap="4px">
            <Typography variant="subtitle2" color="primary">
              {data?.name}{" "}
              {/* {data?.defaultOne && <span style={{ color: "red", fontSize: 12 }}>-- From Vider</span>} */}
            </Typography>
          </Box>
          <Box display="flex" gap={1}>
            {data?.subCategories?.length ? (
              <IconButton onClick={() => setOpen(!open)}>
                {open ? <KeyboardArrowUpRoundedIcon /> : <KeyboardArrowDownRoundedIcon />}
              </IconButton>
            ) : null}
            <ValidateAccess name={[Permissions.DELETE_CATEGORIES, Permissions.EDIT_CATEGORIES]}>
              {!data?.defaultOne && (
                <IconButton onClick={handleClick}>
                  <MoreVertRounded />
                </IconButton>
              )}
            </ValidateAccess>
          </Box>
        </Box>
        {data?.subCategories?.length && open ? (
          <>
            <Divider sx={{ mt: 1 }} />
            <Box flexWrap="wrap" display="flex" p={2} gap={2}>
              {data.subCategories?.map((item: any, index: any) => (
                <Box
                  px="10px"
                  py="5px"
                  borderRadius={2}
                  key={index}
                  border="1px solid rgb(24, 47, 83, 0.2)"
                >
                  <Typography color="primary" variant="caption">
                    {item?.name}
                  </Typography>
                  <ValidateAccess name={Permissions.CREATE_CATEGORIES}>
                  {(item.organization && data?.defaultOne) &&
                    <IconButton onClick={(e) => handleSubCategoryClick(e, item)}>
                      <MoreVertRounded />
                    </IconButton>
                  }
                  </ValidateAccess>
                </Box>
              ))}
              <ValidateAccess name={Permissions.CREATE_CATEGORIES}>
                {data?.defaultOne && <Box display="flex" alignItems={"center"}><Button color="secondary" variant="contained" onClick={() => setOpenAddSubCategory(true)}>
                  <Typography fontSize={"10px"}>+ Add</Typography>
                </Button></Box>}
              </ValidateAccess>
            </Box>
          </>
        ) : null}
      </Box>
      {!data?.defaultOne && (
        <EditCategoryPopover data={data} anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
      )}
      {data?.defaultOne && <AddSubCategory data={data} open={openAddSubCategory} setOpen={setOpenAddSubCategory} />}
      {data?.defaultOne && (
        <EditSubCategoryPopover data={data} selectedSubCategory={selectedSubCategory} anchorEl={anchorSubCatEl} setAnchorEl={setAnchorSubCatEl} />
      )}
    </>
  );
}

export default CategoryCard;
